<div class="modal-container">
  <h2>{{ isEdit ? ('notes.editTitle' | translate) : ('notes.addTitle' | translate) }}</h2>
  <p class="subtitle">{{ 'notes.subtitle' | translate }}</p>

  <form (ngSubmit)="submitNote()" [formGroup]="noteForm">
    <div class="form-group">
      <label>{{ 'notes.fields.title.label' | translate }}</label>
      <input formControlName="title"
             [placeholder]="'notes.fields.title.placeholder' | translate" />
    </div>

    <div class="form-group">
      <label>{{ 'notes.fields.content.label' | translate }}</label>
      <textarea rows="5"
                formControlName="content"
                [placeholder]="'notes.fields.content.placeholder' | translate"></textarea>
    </div>

    <div class="form-actions">
      <app-button
        [isFullWidth]="true"
        [label]="(isEdit ? 'notes.saveChanges' : 'notes.submit') | translate"
        [size]="ButtonSize.LARGE"
        [state]="noteForm.invalid ? ButtonState.DISABLED : ButtonState.REGULAR"
        [type]="ButtonType.PRIMARY"
        (click)="submitNote()"
      ></app-button>

    </div>
  </form>
</div>
